module.exports = __webpack_public_path__ + "static/media/view.b12f1750.svg";